<template>
    <div  :class="baseerp+'div'" >
        <div class="flex a-i-c jcsb"style="margin:5px 14px" >
            <div  class="flex">
                <el-input v-model="search" placeholder="搜索" size="mini" clearable></el-input>
                <el-button  plain style="margin-left: 10px" size="mini" @click="searchFun" >{{$t('button_search_for')}}</el-button>
            </div>
            <el-button  type="primary" :class="baseerp+'btn'" size="mini" @click="add">新增</el-button>
        </div>
        <div style="padding-right: 9px;padding-left: 9px">
            <el-table ref="table" size="mini" row-key="id" :height="tableHeight" border :data="tableData"
                      :cell-style="{textAlign:'center !important'}" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
                <el-table-column type="index" :label="$t('form_serial_number')"  width="50"></el-table-column>
                <el-table-column label="物料数字代码" prop="pzcode" show-overflow-tooltip></el-table-column>
                <el-table-column label="厂家名称" prop="supplier" show-overflow-tooltip></el-table-column>
                <el-table-column label="厂家代码" prop="suppliercode" show-overflow-tooltip></el-table-column>
                <el-table-column label="录入人名称" prop="lruname" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建时间" prop="createtime" show-overflow-tooltip></el-table-column>
                <el-table-column label="归属组" prop="gname" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
                        <el-button type="text" style="color: red" @click="deleteRow(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="pageCurrentChange"
                            @size-change="sizeChange"
                            :page-sizes="[20,50,100]"
                            layout="total,sizes,prev, pager, next"
                            :current-page.sync="currentPage"
                            :total="total"
                            :page-size="pageSize">
            </el-pagination>

        </div>
        <el-dialog style="display: flex;justify-content: center;align-items: center;" top="30px" width="500px"
                   :title="detailTitle" :visible.sync="detailDialog" v-if="detailDialog" :close-on-click-modal="false" @close="detailClose">
            <detail-page :data="detailData" @close="detailClose"></detail-page>
        </el-dialog>


    </div>
</template>

<script>
    import * as API from "./api"
    import DetailPage from "./DetailPage";
    import {baseerp,file_root} from "@/utils/baseUrl";
    export default {
        name: "index",
        components: {DetailPage},
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                file_root:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                detailDialog:false,
                detailTitle:'编辑',
                detailData:{},
                search:'',
                status:'',
                type:''
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp
            this.file_root=file_root
            this.pzsupplierList()

            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

            },
            searchFun(){
                this.currentPage=1;
                this.pzsupplierList();
            },
            add(){
                this.detailData={
                    id:0
                }
                this.detailDialog=true
            },
            editRow(row){
                this.detailData=row
                this.detailDialog=true
            },
            deleteRow(row){
                this.$confirm('是否确认删除','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.deletePzsupplier(row)

                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            detailClose(type='back',data=[]){
                if (type=='back'){

                }else{
                    this.pzsupplierList()
                }
                this.detailDialog=false
            },
            searchFun(){
                this.currentPage=1;
                this.pzsupplierList();
            },
            async pzsupplierList(){
                let param={
                    search:this.search,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                };
                let res=await API.pzsupplierList(param);
                if ( res.code == 1 ){
                    this.total=res.total;
                    this.tableData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async deletePzsupplier(row){
                let param={
                    id:row.id
                };
                let res=await API.deletePzsupplier(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.currentPage=1
                    this.pzsupplierList()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.pzsupplierList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.pzsupplierList();
            },

        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        /*align-items: center;*/
    }
    .w100{
        width: 100%;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 700px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }

    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .dib{
        display: inline-block;
    }
    .ckys{
        width: 340px;
        display: inline-block;
        margin: 0 4px;
        border: 1px solid #DCDFE6;
    }
    .wi{
        width:inherit;
    }
    .w100-480{
        width: calc(100% - 350px);
    }
    .p-5-9{
        padding: 5px 9px;
    }
    .jcsb{
        justify-content: space-between;
    }
    .a-i-c{
        align-items: center;
    }
</style>